module.exports = __webpack_public_path__ + "dekore2.jpeg?f26417367733d414d36b65cb3252ec61";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/dekore2.jpeg
// module id = 321
// module chunks = 0